import React from "react";
import * as axios from "axios";
import { ContentSection, PageWrap, Table } from "@vwfs-bronson/bronson-react";

/**
 * @return {null}
 */
function Licenses() {
  const [licenses, setLicenses] = React.useState(undefined);

  React.useEffect(() => {
    if (!licenses) {
      axios
        .get(process.env.PUBLIC_URL + "/licenses/licenses.json")
        .then(({ data }) => {
          setLicenses(data);
        });
    }
  });

  return (
    <ContentSection>
      <PageWrap>
        {licenses &&
          licenses.map((license) => (
            <div key={license.license} className="u-mb-large">
              <h2>{license.displayName}</h2>
              <a
                href={license.licenseLink}
                target="_blank"
                rel="noopener noreferrer"
              >
                Link zu den Lizenzbedingungen
              </a>
              <Table>
                <Table.Thead>
                  <Table.Tr>
                    <Table.Th highlight>Komponente</Table.Th>
                    <Table.Th highlight>Version</Table.Th>
                    <Table.Th highlight>Copyright</Table.Th>
                  </Table.Tr>
                </Table.Thead>
                <Table.Tbody>
                  {license.packages.map((pkg) => (
                    <Table.Tr key={pkg.name}>
                      <Table.Td>{pkg.name}</Table.Td>
                      <Table.Td>{pkg.version}</Table.Td>
                      <Table.Td>{pkg.copyright}</Table.Td>
                    </Table.Tr>
                  ))}
                </Table.Tbody>
              </Table>
              <p className="u-fluffy-text text-justify">
                {license.licenseText}
              </p>
            </div>
          ))}
      </PageWrap>
    </ContentSection>
  );
}

export default Licenses;
